import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import { NavBar } from "../Navbar/NavBar";
import "../../Assets/CSS/bulkorder.css";
import Inventory from "../../Assets/Images/OMS/Inventory.svg";
import Go from "../../Assets/Images/OMS/go.svg";
import Search from "../../Assets/Images/OMS/search.svg";
import {
  Button,
  Card,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import OMSApproved from "./omsApprovals/omsApproved";
import OMSParentOrder from "./omsApprovals/omsParentOrder";
import OMSParentOrderList from "./omsApprovals/omsParentOrderList";
import OMSChildOrderList from "./omsApprovals/omsChildOrderList";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

const shippingStatusOptions = [
  { label: "Shipping Order In Pending", value: "Pending" },
  { label: "Shipping Order Processing", value: "Order Processing" },
  { label: "Shipping Order Delivered", value: "Order Delivered" },
];

const paymentStatusOptions = [
  { label: "Pending", value: "Pending" },
  { label: "Partially Paid", value: "Paritally Paid" },
  { label: "Fully Paid", value: "Fully Paid" },
  { label: "Overdue", value: "Overdue" },
];

const supplierPaymentStatusOptions = [
  { label: "Pending", value: "Pending" },
  { label: "Partially Paid", value: "Paritally Paid" },
  { label: "Fully Paid", value: "Fully Paid" },
];

const approvalOptions = [{ label: "Pending For Supply", value: "Pending" }];

const approveOptions = [
  { label: "Pending", value: "Pending" },
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
  { label: "Overdue", value: "Overdue" },
];

const parentOrderOptions = [
  { label: "Pending", value: "Pending" },
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
];

const childOrderOptions = [
  { label: "Linked To Parent", value: "Linked" },
  { label: "Not Linked To Parent", value: "NotLinked" },
];

const activeStyled = {
  border: 1,
  bgcolor: "rgb(5, 49, 90)",
  py: 3,
  px: 0,
  color: "white",
};

const inActiveStyled = {
  border: 1,
  bgcolor: "white",
  color: "black",
  py: 3,
  px: 0,
};

const grnOptions = [
  {
    label: "Loading done but GRN not uploaded",
    value: "Loading done but GRN not uploaded",
  },
];

function Oms() {
  const navigate = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem("user_detail"));
  const [searchOrderId, setSearchOrderId] = useState("");
  const [loadedNotReached, setLoadedNotReached] = useState("");
  const [overDueAgenstLoading, setOverDueAgenstLoading] = useState("");
  const [state, setState] = useState({
    supplier_loading: "",
    buyer_unloading: "",
    shipping_status: "",
    supplier_status: "",
    approval: "",
    grn_document_oms: "",
    rm_id: userInfo?.id,
    payment_info: "",
    supplier_payment_info: "",
  });
  const [parentOrderStatus, setParentOrderStatus] = useState('');
  const [childOrderStatus, setChildOrderStatus] = useState('');

  const [prevState, setPreState] = useState(null);

  const [value, setValue] = React.useState("1");
  const [prevValue, setPrevValue] = React.useState(null);

  useEffect(() => {
    if (searchOrderId && !prevState) {
      setPreState({ ...state });
      setState({
        supplier_loading: "",
        buyer_unloading: "",
        shipping_status: "",
        supplier_status: "",
        approval: "",
        grn_document_oms: "",
        rm_id: userInfo?.id,
        payment_info: "",
        supplier_payment_info: "",
      });
    } else if (!searchOrderId && prevState) {
      setState({ ...prevState });
      setPreState(null);
    }
    if (searchOrderId && !prevValue) {
      setPrevValue(value);
      setValue("");
    } else if (!searchOrderId && prevValue) {
      setValue(prevValue);
      setPrevValue(null);
    }
  }, [searchOrderId, prevState, state]);

  const handleChange = (event, newValue) => {
    // reset selection
    setState({
      ...state,
      supplier_loading: newValue === "3" ? false : newValue === "8" ? true : "",
      approval: newValue === "2" ? "Pending" : "",
      grn_document_oms: newValue === "4" ? true : "",
      supplier_payment_info: newValue === "7" ? "Pending" : "",
      payment_info: newValue === "6" ? "Pending" : "",
      buyer_unloading: newValue === "5" || newValue === "8" ? false : "",
    });
    if (newValue === "8") {
      setLoadedNotReached("LoadedNotReached");
    } else {
      setLoadedNotReached("");
    }
    if (newValue === "10") {
      setParentOrderStatus("Pending");
    } else {
      setParentOrderStatus("");
    }
    if (newValue === "11") {
      setChildOrderStatus("Linked");
    } else {
      setChildOrderStatus("");
    }
    setOverDueAgenstLoading("");
    setValue(newValue);
  };

  return (
    <div className="container-fluid">
      {/* <Sidebar /> */}
      <div className="mt-3 ">
        {/* <NavBar /> */}
        <div className="">
          <h3 className="flex justify-start">Orders</h3>
          <div className="flex justify-between">
            <div className="py-2 ">
              <TextField
                className=""
                fullWidth
                onChange={(e) => setSearchOrderId(e.target.value)}
                placeholder="Search by Order ID"
                size="small"
                autoComplete="off"
                type="search"
                value={searchOrderId}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton>
                        <img src={Search} alt="" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="py-2 ">
              <div className="flex-shrink-0 md:ml-5 self-center">
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#151F49",
                    color: "#fff",
                  }}
                  onClick={() => navigate("/oms/inventory")}
                >
                  <IconButton
                    className="me-2"
                    aria-label="toggle dropdown"
                    size="small"
                    edge="end"
                    color="inherit"
                  >
                    <img src={Inventory} alt="" />
                  </IconButton>{" "}
                  Inventory <img src={Go} alt="" className="ms-2" />
                </Button>
              </div>
            </div>
          </div>
          <Box sx={{ width: "100%", typography: "body1", mt: 3 }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  variant="fullWidth"
                  TabIndicatorProps={{
                    style: {
                      // backgroundColor: "rgb(17, 164, 166)",
                      // color:'red'
                    },
                  }}
                >
                  <Tab
                    className={
                      value === "1"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "1" ? activeStyled : inActiveStyled}
                    label="ALL"
                    value="1"
                  />
                  <Tab
                    className={
                      value === "2"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "2" ? activeStyled : inActiveStyled}
                    label="Approval Status"
                    value="2"
                  />
                  <Tab
                    className={
                      value === "3"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "3" ? activeStyled : inActiveStyled}
                    label="Supplier Loading"
                    value="3"
                  />
                  <Tab
                    className={
                      value === "5"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "5" ? activeStyled : inActiveStyled}
                    label="Buyer Unloading"
                    value="5"
                  />
                  <Tab
                    className={
                      value === "4"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "4" ? activeStyled : inActiveStyled}
                    label="GRN"
                    value="4"
                  />
                  <Tab
                    className={
                      value === "7"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "7" ? activeStyled : inActiveStyled}
                    label="Payment Status"
                    value="7"
                  />
                  <Tab
                    className={
                      value === "6"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "6" ? activeStyled : inActiveStyled}
                    label="Collection Status"
                    value="6"
                  />
                  <Tab
                    className={
                      value === "8"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "8" ? activeStyled : inActiveStyled}
                    label="Transit"
                    value="8"
                  />
                  <Tab
                    className={
                      value === "9"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "9" ? activeStyled : inActiveStyled}
                    label="Parent Child Order"
                    value="9"
                  />
                  <Tab
                    className={
                      value === "10"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "10" ? activeStyled : inActiveStyled}
                    label="Parent Orders"
                    value="10"
                  />
                  <Tab
                    className={
                      value === "11"
                        ? "text-light  rounded-top rounded-4 rounded-bottom "
                        : "text-dark rounded-4 rounded-bottom "
                    }
                    sx={value === "11" ? activeStyled : inActiveStyled}
                    label="Child Orders"
                    value="11"
                  />
                </TabList>
              </Box>
              <TabPanel value="2">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-2">
                  {approveOptions?.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <Card
                          role="button"
                          className={`font-medium  ${
                            state?.approval === `${item?.value}`
                              ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500  rounded-md p-2 shadow-xl"
                              : "text-gray-600 dark:text-gray-300 p-2"
                          }`}
                          style={{
                            backgroundColor:
                              state?.approval === `${item?.value}` &&
                              overDueAgenstLoading !== "OverdueAgainstLoading"
                                ? "#05315A"
                                : "",
                            color:
                              state?.approval === `${item?.value}` &&
                              overDueAgenstLoading !== "OverdueAgainstLoading"
                                ? "#fff"
                                : "",
                            borderBottom:
                              state?.approval === `${item?.value}` &&
                              overDueAgenstLoading !== "OverdueAgainstLoading"
                                ? "3px solid #11A4A6"
                                : "1px solid #06082E",
                          }}
                          onClick={() => {
                            setState({
                              ...state,
                              approval: item?.value,
                              grn_document_oms: "",
                              supplier_status: "",
                              shipping_status: "",
                              buyer_unloading: "",
                              supplier_loading: "",
                              payment_info: "",
                              supplier_payment_info: "",
                            });
                            setLoadedNotReached("");
                            setOverDueAgenstLoading("");
                          }}
                        >
                          <div className="flex justify-center gap-2 mt-2">
                            <div>{item?.label}</div>
                          </div>
                        </Card>
                      </>
                    );
                  })}
                </div>
              </TabPanel>
              <TabPanel value="3">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-2">
                  <Card
                    role="button"
                    className={`font-medium  ${
                      state?.supplier_loading === false
                        ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500 p-2 rounded-md shadow-xl"
                        : "text-gray-600 dark:text-gray-300 p-2"
                    }`}
                    style={{
                      backgroundColor:
                        state?.supplier_loading === false ? "#05315A" : "",
                      color: state?.supplier_loading === false ? "#fff" : "",
                      borderBottom:
                        state?.supplier_loading === false
                          ? "3px solid #11A4A6"
                          : "1px solid #06082E",
                    }}
                    onClick={() => {
                      setLoadedNotReached("");
                      setOverDueAgenstLoading("");
                      setState({
                        ...state,
                        supplier_loading: false,
                        approval: "",
                        grn_document_oms: "",
                        supplier_status: "",
                        shipping_status: "",
                        buyer_unloading: "",
                        payment_info: "",
                        supplier_payment_info: "",
                      });
                    }}
                  >
                    <div className="flex justify-center gap-2">
                      {" "}
                      {/* <img src={supplierIncomplete} alt="" width={20} height={20} /> */}
                      <div> Incomplete supplier loading</div>
                    </div>
                  </Card>
                  <Card
                    role="button"
                    className={`font-medium  ${
                      state?.supplier_loading === true &&
                      loadedNotReached !== "LoadedNotReached"
                        ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500 p-2 rounded-md shadow-xl "
                        : "text-gray-600 dark:text-gray-300 p-2"
                    }`}
                    style={{
                      backgroundColor:
                        state?.supplier_loading === true &&
                        loadedNotReached !== "LoadedNotReached"
                          ? "#05315A"
                          : "",
                      color:
                        state?.supplier_loading === true &&
                        loadedNotReached !== "LoadedNotReached"
                          ? "#fff"
                          : "",
                      borderBottom:
                        state?.supplier_loading === true &&
                        loadedNotReached !== "LoadedNotReached"
                          ? "3px solid #11A4A6"
                          : "1px solid #06082E",
                    }}
                    onClick={() => {
                      setLoadedNotReached("");
                      setOverDueAgenstLoading("");
                      setState({
                        ...state,
                        supplier_loading: true,
                        approval: "",
                        grn_document_oms: "",
                        supplier_status: "",
                        shipping_status: "",
                        buyer_unloading: "",
                        payment_info: "",
                        supplier_payment_info: "",
                      });
                    }}
                  >
                    <div className="flex justify-center gap-2">
                      {" "}
                      {/* <img src={supplierComplete} alt="" width={20} height={20} /> */}
                      <div>Completed supplier loading</div>
                    </div>
                  </Card>
                </div>
              </TabPanel>
              <TabPanel value="4">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-2">
                  {grnOptions?.map((item, index) => {
                    return (
                      <>
                        <Card
                          role="button"
                          className={`font-medium  ${
                            state?.grn_document_oms === true
                              ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500 p-2 rounded-md shadow-xl "
                              : "text-gray-600 dark:text-gray-300 p-2"
                          }`}
                          style={{
                            backgroundColor:
                              state?.grn_document_oms === true ? "#05315A" : "",
                            color:
                              state?.grn_document_oms === true ? "#fff" : "",
                            borderBottom:
                              state?.grn_document_oms === true
                                ? "3px solid #11A4A6"
                                : "1px solid #06082E",
                          }}
                          onClick={() => {
                            setLoadedNotReached("");
                            setOverDueAgenstLoading("");
                            setState({
                              ...state,
                              grn_document_oms: true,
                              shipping_status: "",
                              approval: "",
                              supplier_status: "",
                              buyer_unloading: "",
                              supplier_loading: "",
                              payment_info: "",
                              supplier_payment_info: "",
                            });
                          }}
                        >
                          <div className="flex justify-center gap-2">
                            <div>{item?.label}</div>
                          </div>
                        </Card>
                      </>
                    );
                  })}
                </div>
              </TabPanel>
              <TabPanel value="5">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-2">
                  <Card
                    role="button"
                    className={`font-medium  ${
                      state?.buyer_unloading === false &&
                      loadedNotReached !== "LoadedNotReached"
                        ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500 p-2 rounded-md shadow-xl"
                        : "text-gray-600 dark:text-gray-300 p-2"
                    }`}
                    style={{
                      backgroundColor:
                        state?.buyer_unloading === false &&
                        loadedNotReached !== "LoadedNotReached"
                          ? "#05315A"
                          : "",
                      color:
                        state?.buyer_unloading === false &&
                        loadedNotReached !== "LoadedNotReached"
                          ? "#fff"
                          : "",
                      borderBottom:
                        state?.buyer_unloading === false &&
                        loadedNotReached !== "LoadedNotReached"
                          ? "3px solid #11A4A6"
                          : "1px solid #06082E",
                    }}
                    onClick={() => {
                      setLoadedNotReached("");
                      setOverDueAgenstLoading("");
                      setState({
                        ...state,
                        buyer_unloading: false,
                        approval: "",
                        grn_document_oms: "",
                        supplier_status: "",
                        shipping_status: "",
                        supplier_loading: "",
                        payment_info: "",
                        supplier_payment_info: "",
                      });
                    }}
                  >
                    <div className="flex justify-center gap-2">
                      {" "}
                      {/* <img src={BuyerIncomplete} alt="" width={20} height={20} /> */}
                      <div> Incomplete buyer unloading</div>
                    </div>
                  </Card>
                  <Card
                    role="button"
                    className={`font-medium  ${
                      state?.buyer_unloading === true
                        ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500 p-2 rounded-md shadow-xl"
                        : "text-gray-600 dark:text-gray-300 p-2 "
                    }`}
                    style={{
                      backgroundColor:
                        state?.buyer_unloading === true ? "#05315A" : "",
                      color: state?.buyer_unloading === true ? "#fff" : "",
                      borderBottom:
                        state?.buyer_unloading === true
                          ? "3px solid #11A4A6"
                          : "1px solid #06082E",
                    }}
                    onClick={() => {
                      setLoadedNotReached("");
                      setOverDueAgenstLoading("");
                      setState({
                        ...state,
                        buyer_unloading: true,
                        approval: "",
                        grn_document_oms: "",
                        supplier_status: "",
                        shipping_status: "",
                        supplier_loading: "",
                        payment_info: "",
                        supplier_payment_info: "",
                      });
                    }}
                  >
                    <div className="flex justify-center gap-2">
                      {" "}
                      {/* <img src={BuyerComplete} alt="" width={20} height={20} /> */}
                      <div> Completed buyer unloading</div>
                    </div>
                  </Card>
                </div>
              </TabPanel>
              <TabPanel value="6">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-2">
                  {paymentStatusOptions?.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <Card
                          role="button"
                          className={`font-medium  ${
                            state?.payment_info === `${item?.value}`
                              ? "text-blue-600 bg-slate-600 border-2 border-indigo-100 border-b-indigo-500 p-2 rounded-md shadow-xl "
                              : "text-gray-600 dark:text-gray-300 p-2"
                          }`}
                          style={{
                            backgroundColor:
                              state?.payment_info === `${item?.value}`
                                ? "#05315A"
                                : "",
                            color:
                              state?.payment_info === `${item?.value}`
                                ? "#fff"
                                : "",
                            borderBottom:
                              state?.payment_info === `${item?.value}`
                                ? "3px solid #11A4A6"
                                : "1px solid #06082E",
                          }}
                          onClick={() => {
                            setLoadedNotReached("");
                            setOverDueAgenstLoading("");
                            setState({
                              ...state,
                              payment_info: item?.value,
                              shipping_status: "",
                              buyer_unloading: "",
                              approval: "",
                              grn_document_oms: "",
                              supplier_status: "",
                              supplier_loading: "",
                              supplier_payment_info: "",
                            });
                          }}
                        >
                          <div className="flex justify-center gap-2">
                            {/* {item?.value === "" ? (
                            <>
                              {" "}
                              <img
                                src={ApprovedIcon}
                                alt=""
                                width={20}
                                height={20}
                              />
                            </>
                          ) : (
                            ""
                          )} */}

                            <div>{item?.label}</div>
                          </div>
                        </Card>
                      </>
                    );
                  })}
                </div>
              </TabPanel>
              <TabPanel value="7">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-2">
                  {supplierPaymentStatusOptions?.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <Card
                          role="button"
                          className={`font-medium  ${
                            state?.supplier_payment_info === `${item?.value}`
                              ? "text-blue-600 bg-slate-600 border-2 border-indigo-100 border-b-indigo-500 p-2 rounded-md shadow-xl "
                              : "text-gray-600 dark:text-gray-300 p-2"
                          }`}
                          style={{
                            backgroundColor:
                              state?.supplier_payment_info === `${item?.value}`
                                ? "#05315A"
                                : "",
                            color:
                              state?.supplier_payment_info === `${item?.value}`
                                ? "#fff"
                                : "",
                            borderBottom:
                              state?.supplier_payment_info === `${item?.value}`
                                ? "3px solid #11A4A6"
                                : "1px solid #06082E",
                          }}
                          onClick={() => {
                            setLoadedNotReached("");
                            setOverDueAgenstLoading("");
                            setState({
                              ...state,
                              supplier_payment_info: item?.value,
                              payment_info: "",
                              shipping_status: "",
                              buyer_unloading: "",
                              approval: "",
                              grn_document_oms: "",
                              supplier_status: "",
                              supplier_loading: "",
                            });
                          }}
                        >
                          <div className="flex justify-center gap-2">
                            {/* {item?.value === "" ? (
                            <>
                              {" "}
                              <img
                                src={ApprovedIcon}
                                alt=""
                                width={20}
                                height={20}
                              />
                            </>
                          ) : (
                            ""
                          )} */}

                            <div>{item?.label}</div>
                          </div>
                        </Card>
                      </>
                    );
                  })}
                </div>
              </TabPanel>
              <TabPanel value="8">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-2">
                  <Card
                    role="button"
                    className={`font-medium  ${
                      state?.buyer_unloading === false &&
                      state?.supplier_loading
                        ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500 p-2 rounded-md shadow-xl"
                        : "text-gray-600 dark:text-gray-300 p-2"
                    }`}
                    style={{
                      backgroundColor:
                        state?.buyer_unloading === false &&
                        state?.supplier_loading
                          ? "#05315A"
                          : "",
                      color:
                        state?.buyer_unloading === false &&
                        state?.supplier_loading
                          ? "#fff"
                          : "",
                      borderBottom:
                        state?.buyer_unloading === false &&
                        state?.supplier_loading
                          ? "3px solid #11A4A6"
                          : "1px solid #06082E",
                    }}
                    onClick={() => {
                      setState({
                        ...state,
                        buyer_unloading: false,
                        approval: "",
                        grn_document_oms: "",
                        supplier_status: "",
                        shipping_status: "",
                        supplier_loading: true,
                        payment_info: "",
                        supplier_payment_info: "",
                      });
                      setLoadedNotReached("LoadedNotReached");
                      setOverDueAgenstLoading("");
                    }}
                  >
                    <div className="flex justify-center gap-2 mt-2">
                      {" "}
                      {/* <img src={BuyerIncomplete} alt="" width={20} height={20} /> */}
                      <div>Vehicle In Transit</div>
                    </div>
                  </Card>

                  <Card
                    role="button"
                    className={`font-medium  ${
                      state?.approval === "Approved" &&
                      overDueAgenstLoading === "OverdueAgainstLoading"
                        ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500 p-2 rounded-md shadow-xl"
                        : "text-gray-600 dark:text-gray-300 p-2"
                    }`}
                    style={{
                      backgroundColor:
                        state?.approval === "Approved" &&
                        overDueAgenstLoading === "OverdueAgainstLoading"
                          ? "#05315A"
                          : "",
                      color:
                        state?.approval === "Approved" &&
                        overDueAgenstLoading === "OverdueAgainstLoading"
                          ? "#fff"
                          : "",
                      borderBottom:
                        state?.approval === "Approved" &&
                        overDueAgenstLoading === "OverdueAgainstLoading"
                          ? "3px solid #11A4A6"
                          : "1px solid #06082E",
                    }}
                    onClick={() => {
                      setState({
                        ...state,
                        buyer_unloading: "",
                        approval: "Approved",
                        grn_document_oms: "",
                        supplier_status: "",
                        shipping_status: "",
                        supplier_loading: "",
                        payment_info: "",
                        supplier_payment_info: "",
                      });
                      setOverDueAgenstLoading("OverdueAgainstLoading");
                    }}
                  >
                    <div className="flex justify-center gap-2">
                      {" "}
                      {/* <img src={BuyerIncomplete} alt="" width={20} height={20} /> */}
                      <div> Overdue Against Loading</div>
                    </div>
                  </Card>
                </div>
              </TabPanel>
              <TabPanel value="10">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-2">
                  {parentOrderOptions?.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <Card
                          role="button"
                          className={`font-medium  ${
                            parentOrderStatus === `${item?.value}`
                              ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500  rounded-md p-2 shadow-xl"
                              : "text-gray-600 dark:text-gray-300 p-2"
                          }`}
                          style={{
                            backgroundColor:
                              parentOrderStatus === `${item?.value}` &&
                              overDueAgenstLoading !== "OverdueAgainstLoading"
                                ? "#05315A"
                                : "",
                            color:
                              parentOrderStatus === `${item?.value}` &&
                              overDueAgenstLoading !== "OverdueAgainstLoading"
                                ? "#fff"
                                : "",
                            borderBottom:
                              parentOrderStatus === `${item?.value}` &&
                              overDueAgenstLoading !== "OverdueAgainstLoading"
                                ? "3px solid #11A4A6"
                                : "1px solid #06082E",
                          }}
                          onClick={() => {
                            setParentOrderStatus(item?.value);
                          }}
                        >
                          <div className="flex justify-center gap-2 mt-2">
                            <div>{item?.label}</div>
                          </div>
                        </Card>
                      </>
                    );
                  })}
                </div>
              </TabPanel>
              <TabPanel value="11">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-2">
                  {childOrderOptions?.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <Card
                          role="button"
                          className={`font-medium  ${
                            childOrderStatus === `${item?.value}`
                              ? "text-blue-600 border-2 border-indigo-100 border-b-indigo-500  rounded-md p-2 shadow-xl"
                              : "text-gray-600 dark:text-gray-300 p-2"
                          }`}
                          style={{
                            backgroundColor:
                              childOrderStatus === `${item?.value}` &&
                              overDueAgenstLoading !== "OverdueAgainstLoading"
                                ? "#05315A"
                                : "",
                            color:
                              childOrderStatus === `${item?.value}` &&
                              overDueAgenstLoading !== "OverdueAgainstLoading"
                                ? "#fff"
                                : "",
                            borderBottom:
                              childOrderStatus === `${item?.value}` &&
                              overDueAgenstLoading !== "OverdueAgainstLoading"
                                ? "3px solid #11A4A6"
                                : "1px solid #06082E",
                          }}
                          onClick={() => {
                            setChildOrderStatus(item?.value);
                          }}
                        >
                          <div className="flex justify-center gap-2 mt-2">
                            <div>{item?.label}</div>
                          </div>
                        </Card>
                      </>
                    );
                  })}
                </div>
              </TabPanel>
            </TabContext>
          </Box>

          <div>
            {value === "9" ? (
              <OMSParentOrder searchOrderId={searchOrderId} />
            ) : value === "10" ? (
              <OMSParentOrderList
                searchOrderId={searchOrderId}
                parentOrderStatus={parentOrderStatus}
              />
            ) : value === "11" ? (
              <OMSChildOrderList
                state={state}
                searchOrderId={searchOrderId}
                overDueAgenstLoading={overDueAgenstLoading}
                childOrderStatus={childOrderStatus}
              />
            ) : (
              <OMSApproved
                state={state}
                searchOrderId={searchOrderId}
                overDueAgenstLoading={overDueAgenstLoading}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Oms;
